/*
*
* 2015 Apollo Theme
*
*/
var pattern = {
    "ä|æ|ǽ": "ae",
    "ö|œ": "oe",
    "ü": "ue",
    "à|á|â|ã|å|ǻ|ā|ă|ą|ǎ|ª": "a",
    "ç|ć|ĉ|ċ|č": "c",
    "ĝ|ğ|ġ|ģ": "g",
    "ĥ|ħ": "h",
    "ì|í|î|ï|ĩ|ī|ĭ|ǐ|į|ı": "i",
    "ĵ": "j",
    "ķ": "k",
    "ĺ|ļ|ľ|ŀ|ł": "l",
    "ñ|ń|ņ|ň|ŉ": "n",
    "ò|ó|ô|õ|ō|ŏ|ǒ|ő|ơ|ø|ǿ|º": "o",
    "/ŕ|ŗ|ř": "r",
    "ś|ŝ|ş|š|ſ": "s",
    "è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ": "e",
    "ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ": "u",
    "ý|ÿ|ŷ": "y",
    "ì|í|ị|ỉ|ĩ": "i",
    "ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ": "o",
    "ỳ|ý|ỵ|ỷ|ỹ": "y",
    "đ": "d"
};
function slugify(str) {
    str = str.replace(/^\s+|\s+$/g, '');
    str = str.toLowerCase();
    $.each(pattern, function(k) {
        var arr = k.split("|");
        var val = pattern[k];
        var len = arr.length;
        for (var i = 0; i < len; i++) {
            str = str.replace(new RegExp(arr[i],'g'), val);
        }
    });
    str = str.replace(/[^a-z0-9 -]/g, '')// remove invalid chars
    .replace(/\s+/g, '-')// collapse whitespace and replace by -
    .replace(/-+/g, '-');
    // collapse dashes
    
    return str;
}

if (!Object.keys)
    Object.keys = function(o) {
        if (o !== Object(o))
            throw new TypeError('Object.keys called on a non-object');
        var k = [], p;
        for (p in o)
            if (Object.prototype.hasOwnProperty.call(o, p))
                k.push(p);
        return k;
    }
function updatePricingQuickView() {
    
    /*recaculate total price*/
    //try pattern one before pattern 2
    var regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
    var unitPriceTextMatch = jQuery('.quick-view-product .price').text().match(regex);
    
    if (!unitPriceTextMatch) {
        regex = /([0-9]+[.|,][0-9]+)/g;
        unitPriceTextMatch = jQuery('.quick-view-product .price').text().match(regex);
    }
    
    if (unitPriceTextMatch) {
        var unitPriceText = unitPriceTextMatch[0];
        var unitPrice = unitPriceText.replace(/[.|,]/g, '');
        var quantity = parseInt(jQuery('.quick-view-product input[name=quantity]').val());
        var totalPrice = unitPrice * quantity;
        
        var totalPriceText = Shopify.formatMoney(totalPrice, window.money_format);
        
        var textPrice = totalPriceText.match(regex);
        totalPriceText = (textPrice && textPrice.length > 0) ? textPrice[0] : "0";
        
        var regInput = new RegExp(unitPriceText,"g");
        var totalPriceHtml = jQuery('.quick-view-product .price').html().replace(regInput, totalPriceText);
        jQuery('.quick-view-product .total-price span').html(totalPriceHtml);
    }
    /*end of price calculation*/
}
function updateOptionsInSelector(t, sel) {
    var from = (sel != "quickview") ? "" : ".quick-view-product ";
    switch (t) {
    case 0:
        var n = "root";
        var r = $(from + ".single-option-selector:eq(0)");
        break;
    case 1:
        var n = $(from + ".single-option-selector:eq(0)").val();
        var r = $(from + ".single-option-selector:eq(1)");
        break;
    case 2:
        var n = $(from + ".single-option-selector:eq(0)").val();
        n += " / " + $(from + ".single-option-selector:eq(1)").val();
        var r = $(from + ".single-option-selector:eq(2)")
    }
    var i = r.val();
    r.empty();
    var s = (sel != "quickview") ? Shopify.optionsMap[n] : Shopify.optionsMapQuickview[n];
    
    if (typeof s != "undefined") {
        for (var o = 0; o < s.length; o++) {
            var u = s[o];
            var a = $("<option></option>").val(u).html(u);
            r.append(a)
        }
    }
    $(from + '.swatch[data-option-index="' + t + '"] .swatch-element').each(function() {
        if ($.inArray($(this).attr("data-value"), s) !== -1) {
            $(this).removeClass("soldout").show().find(":radio").removeAttr("disabled", "disabled").removeAttr("checked")
        } else {
            $(this).addClass("soldout").hide().find(":radio").removeAttr("checked").attr("disabled", "disabled")
        }
    });
    if ($.inArray(i, s) !== -1) {
        r.val(i)
    }
    r.trigger("change")
}
;
function linkOptionSelectors(t) {
    for (var n = 0; n < t.variants.length; n++) {
        var r = t.variants[n];
        if (r.available) {
            Shopify.optionsMap["root"] = Shopify.optionsMap["root"] || [];
            Shopify.optionsMap["root"].push(r.option1);
            Shopify.optionsMap["root"] = Shopify.uniq(Shopify.optionsMap["root"]);
            if (t.options.length > 1) {
                var i = r.option1;
                Shopify.optionsMap[i] = Shopify.optionsMap[i] || [];
                Shopify.optionsMap[i].push(r.option2);
                Shopify.optionsMap[i] = Shopify.uniq(Shopify.optionsMap[i])
            }
            if (t.options.length === 3) {
                var i = r.option1 + " / " + r.option2;
                Shopify.optionsMap[i] = Shopify.optionsMap[i] || [];
                Shopify.optionsMap[i].push(r.option3);
                Shopify.optionsMap[i] = Shopify.uniq(Shopify.optionsMap[i])
            }
        }
    }
    updateOptionsInSelector(0, "detail");
    if (t.options.length > 1)
        updateOptionsInSelector(1);
    if (t.options.length === 3)
        updateOptionsInSelector(2, "detail");
    $(".single-option-selector:eq(0)").change(function() {
        updateOptionsInSelector(1);
        if (t.options.length === 3)
            updateOptionsInSelector(2, "detail");
        return true
    });
    $(".single-option-selector:eq(1)").change(function() {
        if (t.options.length === 3)
            updateOptionsInSelector(2, "detail");
        return true
    });
}
function linkOptionSelectorsQuickview(t) {
    for (var n = 0; n < t.variants.length; n++) {
        var r = t.variants[n];
        if (r.available) {
            Shopify.optionsMapQuickview["root"] = Shopify.optionsMapQuickview["root"] || [];
            Shopify.optionsMapQuickview["root"].push(r.option1);
            Shopify.optionsMapQuickview["root"] = Shopify.uniq(Shopify.optionsMapQuickview["root"]);
            if (t.options.length > 1) {
                var i = r.option1;
                Shopify.optionsMapQuickview[i] = Shopify.optionsMapQuickview[i] || [];
                Shopify.optionsMapQuickview[i].push(r.option2);
                Shopify.optionsMapQuickview[i] = Shopify.uniq(Shopify.optionsMapQuickview[i])
            }
            if (t.options.length === 3) {
                var i = r.option1 + " / " + r.option2;
                Shopify.optionsMapQuickview[i] = Shopify.optionsMapQuickview[i] || [];
                Shopify.optionsMapQuickview[i].push(r.option3);
                Shopify.optionsMapQuickview[i] = Shopify.uniq(Shopify.optionsMapQuickview[i])
            }
        }
    }
    updateOptionsInSelector(0, "quickview");
    if (t.options.length > 1)
        updateOptionsInSelector(1, "quickview");
    if (t.options.length === 3)
        updateOptionsInSelector(2, "quickview");
    $(".single-option-selector:eq(0)").change(function() {
        updateOptionsInSelector(1, "quickview");
        if (t.options.length === 3)
            updateOptionsInSelector(2, "quickview");
        return true
    });
    $(".single-option-selector:eq(1)").change(function() {
        if (t.options.length === 3)
            updateOptionsInSelector(2, "quickview");
        return true
    });
}
$(function() {
    $('body').on('touchstart.dropdown', '.dropdown-menu', function(e) {
        e.stopPropagation();
    });
    $(document.body).on('click', '[data-toggle="dropdown"]', function() {
        if (!$(this).parent().hasClass('open') && this.href && this.href != '#') {
            window.location.href = this.href;
        }
    });
})
var responsiveflag = false;
var loadIcon = "//hstatic.net/379/1000044379/1000068169/loading.gif?v=820";

$(document).ready(function() {
    //facebook chat
    $('.online-support').hide();
    $('.support-icon-right h3').click(function(e) {
        e.stopPropagation();
        $('.online-support').slideToggle();
    });
    $('.online-support').click(function(e) {
        e.stopPropagation();
    });
    $(document).click(function() {
        $('.online-support').slideUp();
    });
    $(document.body).on("click", "#navbar [data-toggle='dropdown'] .dropdown-menu a", function() {
        //         if(!$(this).parent().hasClass('open') && this.href && this.href != '#'){
        //             window.location.href = this.href;
        //         }
        alert(this.href);
        window.location.href = this.href;
    });
    $(".swatch :radio").change(function() {
        var t = $(this).closest(".swatch").attr("data-option-index");
        var n = $(this).val();
        $(this).closest("form").find(".single-option-selector").eq(t).val(n).trigger("change")
    });
    
    likeThis();
    iniQuickView();
    
    productImage();
    
    responsiveResize();
    $(window).resize(responsiveResize);
    responsiveProductZoom(); 
        $(window).resize(responsiveProductZoom);
    offCanvas();
    
    floatHeader();
    floatTopbar();
    backtotop();
    
    
    changeFloatHeader();
    changeLayoutMode();
    changeHeaderStyle();
    addFilterEffect();
    $(".nav-verticalmenu .caret").click(function(e) {
        $(this).closest("li").toggleClass("menu-open");
        e.stopPropagation();
    });
    $('#page').click(function() {
        if ($("body").hasClass("off-canvas-active")) {
            $('[data-toggle="offcanvas"]').click();
        } else if ($("body").hasClass("off-canvas-left-active")) {
            $('[data-toggle="offcanvas-left"]').click();
        }
    });
    $(".offcanvas-mainnav").click(function(e) {
        e.stopPropagation();
    });
    $(".hover-bimg").mouseenter(function() {
        $(this).closest('.product-image-container').find('.product_img_link').first().find('img').first().attr('src', $(this).data('bimg'));
    });
    $('.btn-group.search-focus').bind('click', function(e) {
        if ($(this).hasClass('active')) {
            $('.nav-search').removeClass('open');
            $(this).removeClass('active');
        } else {
            $(this).addClass('active');
            $('.nav-search').addClass('open');
            $('.nav-search .input-group input[type="text"]').focus();
        }
    });
    
    $('.nav-search .button-close').bind('click', function(e) {
        if ($('.btn-group.search-focus').hasClass('active')) {
            $('.nav-search').removeClass('open');
            $('.btn-group.search-focus').removeClass('active');
        }
    });
    $(document).on('click', '.topbar-button', function() {
        if ($(this).hasClass('action-show')) {
            $('.topbar-popup').slideDown(500);
            $(this).removeClass('action-show').addClass('action-hide');
        } else {
            $('.topbar-popup').slideUp(500);
            $(this).removeClass('action-hide').addClass('action-show');
        }
    });
    $('[data-toggle="tooltip"]').tooltip();
    addCheckedSwatch();
    $('.thumb_item').on('click', function() {
        $(this).each(function() {
            $(this).removeClass('shown');
        });
        $(this).toggleClass('shown');
    })
});
//hover 'other views' images management

$(document).on('mouseover', '#views_block li a', function() {
    displayImage($(this));
});
//add a link on the span 'view full size' and on the big image
$(document).on('click', '#view_full_size, #image-block', function(e) {
    $('#views_block .shown a').click();
});

//========== END PRODUCT PAGE ==========//
//========== QUICK VIEW ==========//

var product = {};
var currentLinkQuickView = '';
var option1 = '';
var option2 = '';
function setButtonNavQuickview() {
    $("#quickview-nav-button a").hide();
    $("#quickview-nav-button a").attr("data-index", "");
    var listProducts = $(currentLinkQuickView).closest(".slide").find("a.quick-view");
    if (listProducts.length > 0) {
        var currentPosition = 0;
        for (var i = 0; i < listProducts.length; i++) {
            if ($(listProducts[i]).data("handle") == $(currentLinkQuickView).data("handle")) {
                currentPosition = i;
                break;
            }
        }
        if (currentPosition < listProducts.length - 1) {
            $("#quickview-nav-button .btn-next-product").show();
            $("#quickview-nav-button .btn-next-product").attr("data-index", currentPosition + 1);
        }
        if (currentPosition > 0) {
            $("#quickview-nav-button .btn-previous-product").show();
            $("#quickview-nav-button .btn-previous-product").attr("data-index", currentPosition - 1);
        }
    }
    $("#quickview-nav-button a").click(function() {
        $("#quickview-nav-button a").hide();
        var indexLink = parseInt($(this).data("index"));
        if (!isNaN(indexLink) && indexLink >= 0) {
            var listProducts = $(currentLinkQuickView).closest(".slide").find("a.quick-view");
            if (listProducts.length > 0 && indexLink < listProducts.length) {
                //$(".quickview-close").trigger("click");
                $(listProducts[indexLink]).trigger("click");
            }
        }
    });
}
function iniQuickView() {
    $(document).on("click", "#thumblist_quickview li", function() {
        changeImageQuickView($(this).find("img:first-child"), "#product-featured-image-quickview");
    });
    $(document).on('click', '.quick-view', function(e) {
        var producthandle = $(this).data("handle");
        currentLinkQuickView = $(this);
        Shopify.getProduct(producthandle, function(product) {
            var qvhtml = $("#quickview-modal").html();
            $(".quick-view-product").html(qvhtml);
            var quickview = $(".quick-view-product");
            var productdes = product.description.replace(/(<([^>]+)>)/ig, "");
            var featured_image = product.featured_image;
            // Reset current link quickview and button navigate in Quickview
            setButtonNavQuickview();
            productdes = productdes.split(" ").splice(0, 30).join(" ") + "...";
            quickview.find(".view_full_size a").attr("title", product.title);
            quickview.find(".view_full_size a").attr("href", featured_image);
            quickview.find(".view_full_size img").attr("src", featured_image);
            quickview.find(".view_full_size img").attr("alt", product.title);
            
            quickview.find(".price").html(Shopify.formatMoney(product.price, window.money_format));
            quickview.find(".product-item").attr("id", "product-" + product.id);
            quickview.find(".variants").attr("id", "product-actions-" + product.id);
            quickview.find(".variants select").attr("id", "product-select-" + product.id);
            
            quickview.find(".product-info .qwp-name").text(product.title);
            quickview.find(".review .Shopify-product-reviews-badge").attr("data-id", product.id);
            quickview.find(".product-info .brand").append("<span>Vendor: </span>" + product.vendor);
            if (product.available) {
                quickview.find(".product-info .availability").append("<p>Available: <span>Available</span></p>");
            } else {
                quickview.find(".product-info .availability").append("<p>Available: <span>Sold out</span></p>");
            }
            quickview.find(".product-info .product-sku").append("<p>SKU: <span>" + product.variants[0].sku + "</span></p>");
            
            quickview.find(".product-description").text(productdes);
            
            if (product.compare_at_price > product.price) {
                quickview.find(".old-price").html(Shopify.formatMoney(product.compare_at_price_max, window.money_format)).show();
                quickview.find(".price").addClass("sale-price")
            } 
            else {
                quickview.find(".old-price").html("");
                quickview.find(".price").removeClass("sale-price")
            }
            if (!product.available) {
                quickview.find("select, input, .dec, .inc, .variants label").remove();
                quickview.find(".add_to_cart_detail").text("Unavailable").addClass("disabled").attr("disabled", "disabled");
                $(".quantity_wanted_p").css("display", "none");
            } 
            else {
                quickViewVariantsSwatch(product, quickview);
                $(".quantity_wanted_p").removeAttr("style");
            }
            
            $("#quick-view-product").fadeIn(500);
            
            $(".view_scroll_spacer").removeClass("hidden");
            
            loadQuickViewSlider(product, quickview);
            quickview.find(".img-product").on("click", function(e) {
                return false;
            });
            //initQuickviewAddToCart();
            
            $(".quick-view").fadeIn(500);
            if ($(".quick-view .total-price").length > 0) {
                $(".quick-view input[name=quantity]").on("change", updatePricingQuickView)
            }
            updatePricingQuickView();
            // Setup listeners to add/subtract from the input
            $(".js-qty__adjust").on("click", function() {
                var el = $(this)
                  , 
                id = el.data("id")
                  , 
                qtySelector = el.siblings(".js-qty__num")
                  , 
                qty = parseInt(qtySelector.val().replace(/\D/g, ''));
                
                var qty = validateQty(qty);
                
                // Add or subtract from the current quantity
                if (el.hasClass("js-qty__adjust--plus")) {
                    qty = qty + 1;
                } else {
                    qty = qty - 1;
                    if (qty <= 1)
                        qty = 1;
                }
                
                // Update the input's number
                qtySelector.val(qty);
                updatePricingQuickView();
            });
            $(".js-qty__num").on("change", function() {
                updatePricingQuickView();
            });
        });
        return false;
    });
    // $(".quick-view").fancybox({
    //  maxWidth    : 1170,
    //  maxHeight   : 800,
    //  width       : '80%',
    //  autoSize    : true,
    //  closeClick  : false,
    //  openSpeed   : 2000,
    //  title   : false
    // });
}
function loadQuickViewSlider(n, r) {
    productImage();
    var s = Shopify.resizeImage(n.featured_image, "grande");
    r.find(".quickview-featured-image").append('<a href="' + n.url + '"><img src="' + s + '" title="' + n.title + '"/><div style="height: 100%; width: 100%; top:0; left:0 z-index: 2000; position: absolute; display: none; background: url(' + window.loading_url + ') 50% 50% no-repeat;"></div></a>');
    if (n.images.length > 0) {
        var o = r.find(".more-view-wrapper ul");
        for (i in n.images) {
            var u = Shopify.resizeImage(n.images[i], "grande");
            var a = Shopify.resizeImage(n.images[i], "compact");
            var f = '<li><a href="javascript:void(0)" data-image="' + u + '"><img src="' + a + '"  /></a></li>';
            o.append(f)
        }
        o.find("a").click(function() {
            var t = r.find(".quickview-featured-image img");
            var n = r.find(".quickview-featured-image div");
            if (t.attr("src") != e(this).attr("data-image")) {
                t.attr("src", e(this).attr("data-image"));
                n.show();
                t.load(function(t) {
                    n.hide();
                    e(this).unbind("load");
                    n.hide()
                })
            }
        });
        if (n.images.length < 5) {
            $(".view_scroll_spacer").addClass("hidden");
        }
        //         o.owlCarousel({
        //           navigation: true,
        //           items: 5,
        //           itemsDesktop: [1199, 4],
        //           itemsDesktopSmall: [979, 3],
        //           itemsTablet: [768, 3],
        //           itemsTabletSmall: [540, 3],
        //           itemsMobile: [360, 3]
        //         }).css("visibility", "visible")
    } else {
        r.find(".quickview-more-views").remove();
        r.find(".quickview-more-view-wrapper-jcarousel").remove()
    }
}
function updateQuantity() {
    $('.js-qty__adjust').on('click', function() {
        var el = $(this)
          , 
        id = el.data('id')
          , 
        qtySelector = el.siblings('.js-qty__num')
          , 
        qty = parseInt(qtySelector.val().replace(/\D/g, ''));
        
        var qty = validateQty(qty);
        
        // Add or subtract from the current quantity
        if (el.hasClass('js-qty__adjust--plus')) {
            qty = qty + 1;
        } else {
            qty = qty - 1;
            if (qty <= 1)
                qty = 1;
        }
        
        // Update the input's number
        qtySelector.val(qty);
        updatePricing();
    });
}
validateQty = function(qty) {
    // Make sure we have a valid integer
    if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
    // We have a number!
    } else {
        // Not a number. Default to 1.
        qty = 1;
    }
    return qty;
}
;
var convertToSlug = function(e) {
    return e.toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-")
}
function quickViewVariantsSwatch(t, quickview) {
    if (t.variants.length > 1) {
        for (var r = 0; r < t.variants.length; r++) {
            var i = t.variants[r];
            var s = '<option value="' + i.id + '">' + i.title + "</option>";
            quickview.find("form.variants > select").append(s)
        }
        new Shopify.OptionSelectors("product-select-" + t.id,{
            product: t,
            onVariantSelected: selectCallbackQuickView
        });
        var o = window.file_url.substring(0, window.file_url.lastIndexOf("?"));
        var u = window.asset_url.substring(0, window.asset_url.lastIndexOf("?"));
        var a = "";
        for (var r = 0; r < t.options.length; r++) {
            a += '<div class="swatch clearfix" data-option-index="' + r + '">';
            a += '<div class="header">' + t.options[r].name + "</div>";
            var f = false;
            if (/Color|Colour/i.test(t.options[r].name)) {
                f = true
            }
            var l = new Array;
            for (var c = 0; c < t.variants.length; c++) {
                var i = t.variants[c];
                var h = i.options[r];
                var p = this.convertToSlug(h);
                var d = "quickview-swatch-" + r + "-" + p;
                if (l.indexOf(h) < 0) {
                    a += '<div data-value="' + h + '" class="swatch-element ' + (f ? "color " : "") + p + (i.available ? " available " : " soldout ") + '">';
                    if (f) {
                        a += '<div class="tooltip">' + h + "</div>"
                    }
                    a += '<input id="' + d + '" type="radio" name="option-' + r + '" value="' + h + '" ' + (c == 0 ? " checked " : "") + (i.available ? "" : " disabled") + " />";
                    if (f) {
                        a += '<label class="' + p + '" for="' + d + '" style="background-color: ' + p + "; background-image: url(" + o + p + '.png)"><img class="crossed-out" src="' + u + 'soldout.png" /><i></i></label>'
                    } 
                    else {
                        a += '<label class="' + p + '" for="' + d + '">' + h + '<img class="crossed-out" src="' + u + 'soldout.png" /></label>'
                    }
                    a += "</div>";
                    if (i.available) {
                        $('.quick-view .swatch[data-option-index="' + r + '"] .' + p).removeClass("soldout").addClass("available").find(":radio").removeAttr("disabled")
                    }
                    l.push(h)
                }
            }
            a += "</div>"
        }
        quickview.find("form.variants > select").after(a);
        quickview.find(".swatch :radio").change(function() {
            var t = $(this).closest(".swatch").attr("data-option-index");
            var q = $(this).val();
            $(this).closest("form").find(".single-option-selector").eq(t).val(q).trigger("change");
        
        });
        if (t.available) {
            Shopify.optionsMapQuickview = {};
            linkOptionSelectorsQuickview(t);
        }
        addCheckedSwatch();
    } 
    else {
        quickview.find("form.variants > select").remove();
        var v = '<input type="hidden" name="id" value="' + t.variants[0].id + '">';
        quickview.find("form.variants").append(v)
    }
}
$(document).on('click', '.quick-view', function(e) {
    e.preventDefault();
});
$(document).on('click', '.quickview-close, #quick-view-product .quickview-overlay', function(e) {
    $("#quick-view-product").fadeOut(500);
});

function displayImage(domAAroundImgThumb) 
{
    if (domAAroundImgThumb.attr('href')) 
    {
        var new_src = domAAroundImgThumb.attr('href').replace('1024x1024', 'large');
        var new_title = domAAroundImgThumb.attr('title');
        var new_href = domAAroundImgThumb.attr('href');
        if ($('#product-featured-image').attr('src') != new_src) 
        {
            $('#product-featured-image').attr({
                'src': new_src,
                'alt': new_title,
                'title': new_title
            });
        }
        $('#views_block li').removeClass('shown');
        $(domAAroundImgThumb).parent().addClass('shown');
    }
}
function responsiveProductZoom() 
{
    if (($(window).width()) >= 992) {
        productZoom('enable');
    } 
    else if (($(window).width()) <= 991) {
        productZoom('disable');
    }
}
function productZoom(status){
    if(status == 'enable') {
        $("#proimage").elevateZoom({
            
            zoomType: "window",
            cursor: 'pointer',
            
            responsive: true,gallery:'thumbs_list', galleryActiveClass: 'active', imageCrossfade: true,scrollZoom : true,onImageSwapComplete: function() {$(".zoomWrapper div").hide()},loadingIcon: loadIcon
        });
        $("#proimage").bind("click", function(e) {var ez = $('#proimage').data('elevateZoom');$.fancybox(ez.getGalleryList()); return false; });
    }
    else{$(document).on('click', '#thumbs_list .thumb_item a', function(){if ($(this).attr('href')){var new_src = $(this).data('image');var new_title = $(this).attr('title');var new_href = $(this).attr('href');if ($('#proimage').attr('src') != new_src){$('#proimage').attr({'src' : new_src,'alt' : new_title,'title' : new_title});}}});}
}
function activeFirstTabs() {
    $('.ap-verticalcategorytabs .tab-content .tab-pane:nth-child(1)').addClass("active");
}
;
function responsiveVerticaltab() {
    $('.ap-verticalcategorytabs').each(function(e) {
        $(this).find('.btn-group').remove();
        tmpTabtitle = $(this).find('.nav-tabs').clone();
        $(tmpTabtitle).children().first().remove();
        var firstItem = $(tmpTabtitle).find('.active').find('span').text();
        var titleTabs = $(tmpTabtitle).html();
        var html = '<div class="btn-group">';
        html += '<button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false">';
        html += firstItem;
        html += '<span class="caret"></span>';
        html += '</button>';
        html += '<ul class="dropdown-menu mobile-menu">';
        html += titleTabs;
        html += '</ul>';
        html += "</div>";
        
        $(this).find('.tabs-left').append(html);
    });
    if (($(window).width()) >= 768) {
        $('.ap-verticalcategorytabs').each(function() {
            $(this).find('.btn-group').remove();
        })
    } 
    else if (($(window).width()) <= 767) {
        $(".mobile-menu li.active a").trigger("click");
        $(".ap-verticalcategorytabs .mobile-menu li a").bind("click", function() {
            $(this).closest("ul").find("li").removeClass("active");
            var indexTab = $(this).closest("li").index();
            $(this).closest(".btn-group").find("button").html($(this).text() + '<span class="caret"></span>');
            vertab = $(this).closest(".ap-verticalcategorytabs").find('.nav-tabs').find('li');
            $(vertab).removeClass("active");
            $(vertab).eq(indexTab + 1).addClass("active");
        });
    }
}
function productImage() {
    $('#thumblist_quickview').width(parseInt($('#thumblist_quickview >li').outerWidth(true) * $('#thumblist_quickview >li').width) + 'px');
    $('#thumbs_list_quickview').serialScroll({
        items: 'li:visible',
        prev: '#view_scroll_left_quickview',
        next: '#view_scroll_right_quickview',
        axis: 'x',
        start: 0,
        stop: true,
        duration: 700,
        step: 2,
        lazy: true,
        lock: false,
        force: false,
        cycle: false
    });
    $("#thumbs_list_quickview").trigger('goto', [3]);
    
    $('#thumblist').owlCarousel({
        navigation: true,
        items: 4,
        itemsDesktop: [1199, 4],
        itemsDesktopSmall: [979, 4],
        itemsTablet: [768, 4],
        itemsTabletSmall: [540, 4],
        itemsMobile: [360, 4]
    });
    $('.thumbs_list_frame').height(parseInt($('.thumbs_list_frame >li').outerHeight(true) * $('.thumbs_list_frame >li').height) + 'px');
    $('.thumbs_list').serialScroll({
        items: 'li:visible',
        prev: '.view_scroll_left',
        next: '.view_scroll_right',
        axis: 'y',
        start: 0,
        stop: true,
        duration: 700,
        step: 2,
        lazy: true,
        lock: false,
        force: false,
        cycle: false
    });

        $('#thumbnails').height(parseInt($('#thumbnails >li').outerHeight(true) * $('#thumbnails >li').height) + 'px');
                $('#thumbnail_wr').serialScroll({
                        items: 'li:visible',
                        prev: '#view_scroll_top',
                        next: '#view_scroll_bot',
                        axis: 'y',
                        start: 0,
                        stop: true,
                        duration: 700,
                        step: 2,
                        lazy: true,
                        lock: false,
                        force: false,
                        cycle: false
                });

    if (!!$.prototype.fancybox) {
        $('li:visible .fancybox, .fancybox.shown').fancybox({
            'hideOnContentClick': true,
            'openEffect': 'elastic',
            'closeEffect': 'elastic'
        });
    }
}

// Used to compensante Chrome/Safari bug (they don't care about scroll bar for width)
function scrollCompensate() 
{
    var inner = document.createElement('p');
    inner.style.width = "100%";
    inner.style.height = "200px";
    
    var outer = document.createElement('div');
    outer.style.position = "absolute";
    outer.style.top = "0px";
    outer.style.left = "0px";
    outer.style.visibility = "hidden";
    outer.style.width = "200px";
    outer.style.height = "150px";
    outer.style.overflow = "hidden";
    outer.appendChild(inner);
    
    document.body.appendChild(outer);
    var w1 = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    var w2 = inner.offsetWidth;
    if (w1 == w2)
        w2 = outer.clientWidth;
    
    document.body.removeChild(outer);
    
    return ( w1 - w2) ;
}
function responsiveResize() 
{
    compensante = scrollCompensate();
    if (($(window).width() + scrollCompensate()) <= 767 && responsiveflag == false) 
    {
        accordion('enable');
        accordionFooter('enable');
        responsiveflag = true;
    } 
    else if (($(window).width() + scrollCompensate()) >= 768) 
    {
        accordion('disable');
        accordionFooter('disable');
        responsiveflag = false;
    }
}
function setLeftColumn() {
    $('body').append($('<div class="over-cover" style="display:none"></div><div class="drag-target"></div>'));
    $('.drag-target').click(function() {
        $('#left_column').addClass('side-nav');
        $('.over-cover').show();
    });
}
function offCanvas() {
    $('[data-toggle="offcanvas"]').click(function(e) {
        var menuCanvas = $(this).data('target');
        $(this).toggleClass('open');
        $(menuCanvas).toggleClass('active');
        $('body').toggleClass('off-canvas-active');
        var heightCanvas = $(window).height();
        $(menuCanvas).css({
            'min-height': heightCanvas
        });
        e.stopPropagation();
    });
    $('.off-canvas-nav').click(function() {
        $('[data-toggle="offcanvas"]').click();
    });
    $('[data-toggle="offcanvas-left"]').click(function(e) {
        var menuCanvas = $(this).data('target');
        $(this).toggleClass('open');
        $(menuCanvas).toggleClass('active');
        $('body').toggleClass('off-canvas-left-active');
        var heightCanvas = $(window).height();
        $(menuCanvas).css({
            'min-height': heightCanvas
        });
        e.stopPropagation();
    });
}
function accordion(status) 
{
    leftColumnBlocks = $('#left_column');
    if (status == 'enable') 
    {
        if (!$('#left_column').hasClass('accordion')) {
            $('#right_column .block .title_block, #left_column .block .title_block').on('click', function() {
                $(this).toggleClass('active').parent().find('.block_content').stop().slideToggle('medium');
            });
        }
        
        $('#right_column, #left_column').addClass('accordion');
    } 
    else 
    {
        $('#right_column .block .title_block, #left_column .block .title_block').removeClass('active').off().parent().find('.block_content').removeAttr('style').slideDown('fast');
        $('#left_column, #right_column').removeClass('accordion');
    }
}
function accordionFooter(status) {
    if (status == 'enable') {
        if (!$('#footercenter').hasClass('accordion')) {
            $('#footercenter .footer-block h4').on('click', function() {
                $(this).toggleClass('active').parent().find('.block_content').stop().slideToggle('medium');
            })
        }
        $('#footercenter').addClass('accordion').find('.block_content').slideUp('fast');
    } 
    else {
        $('.footer-block h4').removeClass('active').off().parent().find('.block_content').removeAttr('style').slideDown('fast');
        $('#footercenter').removeClass('accordion');
    }
}
//Float Menu
function processFloatHeader(headerAdd, scroolAction) {
    if (headerAdd) {
        var mb = 0;
        var intro = 0;
        var hideheight = 0;
        hideheight = $("#topbar").height() + mb + mb + intro;
        
        var hh = $("#header-top").height() + mb;
        var updateTopbar = function() {
            var pos = $(window).scrollTop();
            if (pos > hideheight + $("#header-top").height() / 2) {
                $("#page").css("padding-top", hh);
                $("#header-top").addClass('hide-bar');
                $("#header-top").addClass("navbar navbar-fixed-top");
            } else {
                $('#page').css("padding-top", 0);
                $("#header-top").removeClass('hide-bar');
                $('#header-top').removeClass('navbar-fixed-top');
                $('#header-top').removeClass('navbar');
            }
        }
        updateTopbar();
    } else {
        $('#page').css("padding-top", 0);
        $("#header-top").removeClass('hide-bar');
        $('#header-top').removeClass('navbar-fixed-top');
        $('#header-top').removeClass('navbar');
    }
}
function processFloatTopbar(topbarAdd, scroolAction) {
    if (topbarAdd) {
        $("#header").addClass("navbar-fixed-top");
        $("#page").css("padding-top", $("#header").height());
        var hideheightBar = $("#header").height() + 120;
        var pos = $(window).scrollTop();
        if (scroolAction && pos >= hideheightBar) {
            $("#header-main").addClass('hidden');
            $(".main-menu").addClass('hidden');
            $("#topbar").css("box-shadow", "0 3px 2px 0 rgba(0,0,0,0.25)");
        } else {
            $("#header-main").removeClass('hidden');
            $(".main-menu").removeClass('hidden');
            $("#topbar").css("box-shadow", "none");
        }
    } else {
        $("#header").removeClass("navbar-fixed-top");
        $("#page").css("padding-top", '');
        $("#header-main").removeClass('hidden');
        $(".main-menu").removeClass('hidden');
        $("#topbar").css("margin-top", 0);
    }

}
function floatHeader() {
    $(window).resize(function() {
        if (!$("body").hasClass("keep-header") || $(window).width() <= 990) {
            return;
        }
        if ($(window).width() <= 990) 
        {
            processFloatHeader(0, 0);
        } 
        else if ($(window).width() > 990) 
        {
            if ($("body").hasClass("keep-header"))
                processFloatHeader(1, 1);
        }
    });
    $(window).scroll(function(e) {
        if (!$("body").hasClass("keep-header"))
            return;
        console.log("abcc");
        if ($(window).width() > 990) {
            if ($("body").hasClass("keep-header")) {
                processFloatHeader(1, 1);
            }
        }
    });
}
function floatTopbar() {
    $(window).resize(function() {
        if (!$("body").hasClass("keep-topbar") || $(window).width() <= 990) {
            return;
        }
        if ($(window).width() <= 990) 
        {
            processFloatTopbar(0, 0);
        } 
        else if ($(window).width() > 990) 
        {
            if ($("body").hasClass("keep-topbar"))
                processFloatTopbar(1, 1);
        }
    });
    $(window).scroll(function() {
        if (!$("body").hasClass("keep-topbar"))
            return;
        if ($(window).width() > 990) {
            processFloatTopbar(1, 1);
        
        }
    });
}
// Back to top
function backtotop() {
    $("#back-top,#btn_position").hide();
    $(function() {
        $(window).scroll(function() {
            if ($(this).scrollTop() > 100) {
                $('#back-top,#btn_position').fadeIn();
            } else {
                $('#back-top,#btn_position').fadeOut();
            }
        });
        $('#back-top').click(function() {
            $('body,html').animate({
                scrollTop: 0
            }, 800);
            return false;
        });
    });
}
function panelTool() {
    $('#paneltool .panelbutton').click(function() {
        $('#paneltool .paneltool').toggleClass('active');
    });
}
function changeFloatHeader() {
    $('#floatHeader').click(function() {
        if ($('body').hasClass('keep-header')) {
            $('body').removeClass('keep-header');
            console.log("da vao float header");
            processFloatHeader(0, 0);
        } 
        else {
            processFloatTopbar(0, 0);
            $('body').addClass('keep-header');
            $('body').removeClass('keep-topbar');
            $("#floatTopbar").prop("checked", false);
        }
        ;
    });
    $('#floatTopbar').click(function() {
        if ($('body').hasClass('keep-topbar')) {
            $('body').removeClass('keep-topbar');
            processFloatTopbar(0, 0);
        } 
        else {
            processFloatHeader(0, 0);
            $('body').addClass('keep-topbar');
            $('body').removeClass('keep-header');
            $("#floatHeader").prop("checked", false);
        }
        ;
    });
}
function changeLayoutMode() {
    $('.dynamic-update-layout').click(function() {
        var currentLayoutMode = $('.dynamic-update-layout.selected').data('layout-mode');
        if (!$(this).hasClass('selected')) 
        {
            $('.dynamic-update-layout').removeClass('selected');
            $(this).addClass('selected');
            selectedLayout = $(this).data('layout-mode');
            $('body').removeClass(currentLayoutMode);
            $('body').addClass(selectedLayout);
        }
    });
}
function changeHeaderStyle() {
    $('.dynamic-update-header').click(function() {
        var currentHeaderMode = $('.dynamic-update-header.selected').data('header-style');
        if (!$(this).hasClass('selected')) 
        {
            $('.dynamic-update-header').removeClass('selected');
            $(this).addClass('selected');
            selectedHeaderStyle = $(this).data('header-style');
            $('body').removeClass(currentHeaderMode);
            $('body').addClass(selectedHeaderStyle);
        }
    });
}
function addFilterEffect() {
    if ($("#catalog_block").length && $("#catalog_block").hasClass('ajax-filter')) {
        //if this page is collection page
        if ($('.catalog_filters').length) {
            $('.advanced-filter').each(function() {
                dataGroup = $(this).data('group');
                if (dataGroup != "Vendor") {
                    activeFilter = '';
                    if ($(this).hasClass('active-filter'))
                        activeFilter = ' checked="checked"';
                    
                    $('a', $(this)).each(function() {
                        var dataHandle = slugify($(this).parent().data("handle"));
                        //put link for filter when not in collection page
                        if (!$('body').hasClass('template-collection')) {
                            $(this).attr('href', '/collections/all/' + dataHandle);
                            $(this).unbind("click");
                        } else {
                            $('<input class="chkval" type="checkbox" name=' + dataGroup + activeFilter + ' value="' + dataHandle + '"/>').insertBefore($(this));
                            $(this).click(function(event) {
                                chkVal = $(this).parent().find('.chkval');
                                chkVal.prop("checked", !chkVal.prop("checked"));
                                $(this).parent().toggleClass("active-filter");
                                FilterLoadResult();
                                return false;
                            });
                        }
                    })
                }
            });
        }
        
        //add ajax for sort
        $("#SortBy").change(function(event) {
            event.preventDefault();
            
            var url = window.location.href;
            if (url.indexOf('search') > 0) {
                switch ($(this).val()) {
                case 'title-ascending':
                    url = replaceUrlParam(url, 'sortby', '(title:product=asc)');
                    break;
                case 'title-descending':
                    url = replaceUrlParam(url, 'sortby', '(title:product=des)');
                    break;
                case 'price-ascending':
                    url = replaceUrlParam(url, 'sortby', '(price:product=asc)');
                    break;
                case 'price-descending':
                    url = replaceUrlParam(url, 'sortby', '(price:product=des)');
                    break;
                case 'created-ascending':
                    url = replaceUrlParam(url, 'sortby', '(created:product=asc)');
                    break;
                case 'created-descending':
                    url = replaceUrlParam(url, 'sortby', '(created:product=des)');
                    break;
                }
            } else {
                url = replaceUrlParam(url, 'sort_by', $(this).val());
            }
            
            processCollectionAjax(url);
            return false;
        });
        //add ajax for view
        $(".change-view").click(function(event) {
            event.preventDefault();
            if ($(this).hasClass('change-view--active'))
                return false;
            $(".change-view").removeClass('change-view--active');
            $(this).addClass('change-view--active');
            var url = window.location.href;
            url = replaceUrlParam(url, 'view', $(this).data('view'));
            //add class for product list            
            processCollectionAjax(url);
            $('.product_list').removeClass('list').removeClass('grid').addClass($(this).data('view'));
            return false;
        });
        
        pagingCollection();
    }
}

function pagingCollection() {
    activeNumber = parseInt($('.pagination li.active span').html());
    
    $('#pagination .pagination a').click(function() {
        var pageNumber = 0;
        //previous
        
        if ($(this).parent().hasClass('pagination_previous')) {
            pageNumber = activeNumber - 1;
        }
        //next
         
        else if ($(this).parent().hasClass('pagination_next')) {
            pageNumber = activeNumber + 1;
        }
        //normal paging
         
        else {
            pageNumber = parseInt($(this).html());
        }
        if (pageNumber > 0) {
            var url = window.location.href;
            url = replaceUrlParam(url, 'page', pageNumber);
            
            processCollectionAjax(url);
        }
        return false;
    });
}
function FilterLoadResult() {
    var ismore = 0;
    collecionid = $("#catalog_block").data("collection");
    if (collecionid)
        q = "filter=((collectionid:product=" + collecionid + ")";
    else
        q = "filter=((collectionid:product>=0)";
    
    //search by size
    textsize = '';
    $('#ul_catalog_size .chkval').each(function() {
        if ($(this).is(":checked")) {
            ismore++;
            vc = $(this).val().toLowerCase();
            textsize += (textsize ? "||" : "") + "(variant:product=" + vc + ")";
        }
    });
    textcolor = '';
    $('#ul_catalog_color .chkval').each(function() {
        if ($(this).is(":checked")) {
            ismore++;
            vc = $(this).val().toLowerCase();
            textcolor += (textcolor ? "||" : "") + "(variant:product=" + vc + ")";
        }
    });
    textPrice = '';
    $('#ul_catalog_price .chkval').each(function() {
        if ($(this).is(":checked")) {
            ismore++;
            vc = $(this).val().toLowerCase();
            if (vc.indexOf('duoi') > -1) 
            {
                vc = vc.replace('duoi-', '<=');
                textPrice += (textPrice ? "||" : "") + "(price:product" + vc + ")";
            } else if (vc.indexOf('tren') > -1) {
                vc = vc.replace('tren-', '>');
                textPrice += (textPrice ? "||" : "") + "(price:product" + vc + ")";
            } else {
                vc = vc.split("-");
                tmpprice = '';
                for (var i in vc) {
                    tmpprice += (tmpprice ? "&&" : "") + "(price:product" + (i == 0 ? ">" : "<=") + vc[i] + ")";
                }
                textPrice += (textPrice ? "||" : "") + "(" + tmpprice + ")";
            }
        }
    });
    
    
    if ((textsize + textcolor + textPrice) ) 
    {
        var url = '/search?q=' + q;
        if (textsize) {
            if (textsize.split("||").length > 1) {
                url += "&&" + "(" + textsize + ")";
            } else {
                url += "&&" + textsize;
            }
        }
        if (textcolor) {
            if (textcolor.split("||").length > 1) {
                url += "&&" + "(" + textcolor + ")";
            } else {
                url += "&&" + textcolor;
            }
        }
        if (textPrice) {
            if (textPrice.split("||").length > 1) {
                url += "&&" + "(" + textPrice + ")";
            } else {
                url += "&&" + textPrice;
            }
        }
        
        
        url = url + ")";
        //check change view
        view = $('.change-view--active').data('view');
        if (view == "list")
            url = replaceUrlParam(url, 'view', $(this).data('view'));
        
        //check change sort
        sortby = $("#SortBy").val();
        if (sortby != "manual") {
            switch (sortby) {
            case 'title-ascending':
                url = replaceUrlParam(url, 'sortby', '(title:product=asc)');
                break;
            case 'title-descending':
                url = replaceUrlParam(url, 'sortby', '(title:product=des)');
                break;
            case 'price-ascending':
                url = replaceUrlParam(url, 'sortby', '(price:product=asc)');
                break;
            case 'price-descending':
                url = replaceUrlParam(url, 'sortby', '(price:product=des)');
                break;
            case 'created-ascending':
                url = replaceUrlParam(url, 'sortby', '(created:product=asc)');
                break;
            case 'created-descending':
                url = replaceUrlParam(url, 'sortby', '(created:product=des)');
                break;
            }
        }
        processCollectionAjax(url);
    }
}
function processCollectionAjax(url) {
    $.ajax({
        type: 'GET',
        url: url,
        data: {},
        beforeSend: function() {
            $('.product_list').addClass('loading');
        },
        complete: function(data) {
            //console.log(data.responseText);
            $('.product_list').html($(".product_list", data.responseText).html());
            $('#pagination').remove();
            $('.content_sortPagiBar').html($(".content_sortPagiBar", data.responseText).html());
            $('.product_list').removeClass('loading');
            
            history.pushState({
                page: url
            }, url, url);
            pagingCollection();
        }
    });
}
function addCheckedSwatch() {
    $('.swatch .color label').on('click', function() {
        $('.swatch .color').each(function() {
            $(this).find('label').removeClass('checkedBox');
        });
        $(this).addClass('checkedBox');
    });
}
/*START LEFT- RIGHT MENU*/
function setLeftColumn() {
    if ($("#left_column").length > 0) {
        if ($(".over-cover").length == 0) {
            $('body').append($('<div class="over-cover"></div><div class="drag-target-left"><div class="drag-panel-left"></div></div>'));
            $('body').append($('<a href="javascript:;" data-activates="slide-out" class="button-collapse-left"><i class="mdi-navigation-menu"></i></a>'));
        }
        
        $(".button-collapse-left").click(function() {
            $(".drag-target-left, .button-collapse-left").addClass("hide");
            $("body").addClass("move-left-to-right");
            $('#left_column').css("left", "-400px");
            setTimeout(function() {
                $("#left_column").parent().addClass("side-nav-container-left");
                $("#left_column").addClass("side-nav-left");
            }, 200);
        });
        $(".over-cover").click(function() {
            $(".drag-target-left, .button-collapse-left").removeClass("hide");
            $("#left_column").parent().removeClass("side-nav-container-left");
            $("#left_column").removeClass("side-nav-left");
            $("body").removeClass("move-left-to-right");
            $(".box-left-menu").addClass("menu-close");
            $('#left_column').css("left", "");
        });
        $(".drag-target-left").click(function() {
            console.log("drag-target click");
            $(".button-collapse-left").trigger("click");
        });
    }
}
function setRightColumn() {
    if ($("#right_column").length > 0) {
        if ($(".over-cover").length == 0) {
            $('body').append($('<div class="over-cover"></div><div class="drag-target-right"><div class="drag-panel-right"></div></div>'));
            $('body').append($('<a href="javascript:;" data-activates="slide-out" class="button-collapse-right"><i class="mdi-navigation-menu"></i></a>'));
        }
        
        $(".button-collapse-right").click(function() {
            $(".drag-target-right, .button-collapse-right").addClass("hide");
            $("body").addClass("move-right-to-left");
            $('#right_column').css("right", "-400px");
            setTimeout(function() {
                $("#right_column").parent().addClass("side-nav-container-right");
                $("#right_column").addClass("side-nav-right");
            }, 200);
        });
        $(".over-cover").click(function() {
            $(".drag-target-right, .button-collapse-right").removeClass("hide");
            $("#right_column").parent().removeClass("side-nav-container-right");
            $("#right_column").removeClass("side-nav-right");
            $("body").removeClass("move-right-to-left");
            $(".box-right-menu").addClass("menu-close");
            $('#right_column').css("right", "");
        });
        $(".drag-target-right").click(function() {
            console.log("drag-target click");
            $(".button-collapse-right").trigger("click");
        });
    }
}
/*END LEFT- RIGHT MENU*/ 

/* Custom script*/ 
function likeThis() {
                $(".btn-like").click(function() {
                    $(this).parent().find('.form-like-wr').toggleClass("active");
                });
                $(".jq-like ").hover(function() {
                    $(this).parent().find('.form-like-wr').addClass("active");
                },function() {
$(this).parent().find('.form-like-wr').removeClass("active");
}
);
}

// Ajax search
(function($) {
    var getHash = function () {
      return window.location.hash;
    };
    var updateHash = function (hash) {
        window.location.hash = '#' + hash;
        $('#' + hash).attr('tabindex', -1).focus();
    };
    $(function(){
        $('body').on('touchstart.dropdown', '.dropdown-menu', function (e) { 
          e.stopPropagation(); 
        });
        $(document.body).on('click', '[data-toggle="dropdown"]' ,function(){
          if(!$(this).parent().hasClass('open') && this.href && this.href != '#'){
              window.location.href = this.href;
          }
        });
    })
  $(document).ready(function() {
        apollo.init();
        
          AP_Search.init();
        
    });
    var AP_Search = {
      init : function(){
        this.ajaxSearch();
      },
      ajaxProductItems : function(){
        var result = new Array();
        var search_url = '/collections/all?view=ajax';

        $.ajax({
          type: 'GET',
          url: search_url,
          success: function (data) {

            data = '<div>' + data + '</div>';
            data = data.trim();

            var elements = $(data).find('.aps-ajax');

            if( 0 < elements.length ){
              elements.each(function() {

                var title = $.trim(this.getAttribute('data-title'));
                var price = $.trim(this.getAttribute('data-price'));
                var handle = $.trim(this.getAttribute('data-handle'));
                var image = $.trim(this.getAttribute('data-img'));

                var item = new Object();
                item.title = title;
                item.price = price;
                item.handle = handle;
                item.featured_image = image;

                result.push(item);
              });
            }else{
              //todo : return not found here
            }  

          },
          dataType: 'html'
        });

        return result;
      }
    
      ,ajaxSearch : function(){
        var products = AP_Search.ajaxProductItems();
        $( "#search_query_top" ).keyup(function() {
          var $this = $(this);
          var keyword = $this.val().toLowerCase();
          $('#ap-ajax-search').hide();
          if(keyword.length >= 2){
            $(this).removeClass('error warning valid').addClass('valid');

            var result = $('#ap-ajax-search .aps-results').empty();

            var j = 0;

            for (var i = 0; i < products.length; i++) {

              var item = products[i];

              var title = item.title;
              var price = item.price;
              var handle = item.handle;
              var image = item.featured_image;

              if(title.toLowerCase().indexOf(keyword) > -1){

                var j = j + 1;

                var markedString = title.replace(new RegExp('(' + keyword + ')', 'gi'), '<span class="marked">$1</span>');

                var template = '<li class="product-block"><a class="product_img_link" href="/products/'+ handle +'">'+ '<img style="max-width: 80px; float: left;margin-right: 5px" src="' + image + '" />' 
                +'</a><a class="product-name" href="/products/'+ handle +'">'+ markedString +'</a><div class="content_price"><span class="price product-price">'+ price + '</span></div></li>';

                if(j <= 10 ){
                  result.append(template);
                }

              }
            }

            if($('#ap-ajax-search .aps-results li').length < 1){
              result.append('<li><p>No result for your search</p></li>')
            }

            if($('#ap-ajax-search .aps-results li').length){
              $('#ap-ajax-search').show();              
            }

          }else{

            if(keyword.length == 1){
              $(this).removeClass('error warning valid').addClass('error');
              //todo : change the place holder to notice customer

              var text = '<li><p>You must enter at least 2 characters</p></li>';
              var result = $('#ap-ajax-search .aps-results').empty();
              result.append(text);
              $('#ap-ajax-search').show();
            }
            else{
              $('#ap-ajax-search').hide();
            }
          }
        });

        $(document).on('click','#page',function(e){
          $('#ap-ajax-search').hide();
        });
      }
    }
    var apollo = {
        isFilterAjaxClick: false,
        init: function() {
          this.loginForms();
            //this.initFilter();
        },
        loginForms: function() {
            function showRecoverPasswordForm() {
                $('#RecoverPasswordForm').show();
                $('#CustomerLoginForm').hide();
            }
            function hideRecoverPasswordForm() {
                $('#RecoverPasswordForm').hide();
                $('#CustomerLoginForm').show();
            }
            $('#RecoverPassword').on('click', function(evt) {
                evt.preventDefault();
                showRecoverPasswordForm();
            });
            $('#HideRecoverPasswordLink').on('click', function(evt) {
                evt.preventDefault();
                hideRecoverPasswordForm();
            });
            if (getHash() == '#recover') {
                showRecoverPasswordForm();
            }
        },
        resetPasswordSuccess: function() {
            $('#ResetSuccess').show();
        },
        showLoading: function() {
            $('#loading').show();
        },
        hideLoading: function() {
            $('#loading').hide();
        },
        initFilter: function() {
            apollo.filterMapSidebar();
        }
    }
    
})(jQuery);

        function thumbs() {
            $('#thumbnails .thumbnail').eq(0).addClass('active');
            $('#thumbnails .thumbnail').click(function(){
                var position = $(this).index();
                $('.thumbnails .thumbnail').removeClass('active');
                $(this).addClass('active');
                $('#product_owl').trigger('owl.goTo', position);
            });

            if ($('#thumbnails li').length > 4)
            {
                $('.js-thumb').removeClass('thumbs').addClass('thumbs');
            }
            else{
                $('.js-thumb').removeClass('thumbs')
            }
        }
        function changeslide(){
            var slide = function(){
                $(this).owlCarousel({
                    singleItem:true,
                    lazyLoad : true,
                    dots:true,
                    afterInit: function (elem) {
                        var current = this.currentItem;
                        $('.owl-wrapper .owl-item').eq(current).find('img').addClass('imgzoom');
                        $(".imgzoom").elevateZoom({
                            zoomType: "inner",
                            cursor: "crosshair"
                        });
                    },
                    afterMove: function (elem) {
                        $.removeData('.imgzoom', 'elevateZoom');
                        $('.zoomContainer').remove();
                        $('.owl-wrapper .owl-item img').removeClass('imgzoom');
                        var current = this.currentItem;
                        $('.owl-wrapper .owl-item').eq(current).find('img').addClass('imgzoom');
                        $(".imgzoom").elevateZoom({
                            zoomType: "inner",
                            cursor: "crosshair"
                        });
                    }
                }); 
            }       

            var switchSlide = function(opt){
                if($("#product_owl").data('owlCarousel'))
                    $('#product_owl').data('owlCarousel').destroy();
                $("#product_owl").html('');
                $('#product_owl .item').remove();
                $('.images .item[data-option='+opt+']').clone().appendTo('#product_owl');
                $('.zoomContainer').remove();
                $('.owl-wrapper .owl-item img').removeClass('imgzoom');
                $('#product_owl').each(slide);
                $('.thumbnails .thumbnail').remove();
                $('.thumbnails-hidden .thumbnail[data-option='+opt+']').clone().appendTo('.thumbnails');
                thumbs();
            }
            value = $('.single-option-selector').val();
            icheck = false;
            $('.images .item').each(function(){
                if ( $(this).attr('data-option') == value ) {
                    icheck=true;
                    return false;
                }
            });
            if ( icheck == true ) {
            switchSlide((value));
            }
        }